import {
  Asset,
  Building,
  IntroVideos,
  Levels,
  Project,
  Scene,
  Settings,
  Stage,
  Theme,
  Unit,
} from '@marketertechnologies/property-picker';
import { Camelized, camelizeKeys } from 'humps';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getSplashScreenData } from '~/queries/getSplashScreen';

export type SplashScreenResponse = {
  apiPublished: boolean;
  portalPublished: boolean;
  mainScene: Scene;
  settings: Settings;
  project: Project;
  theme: Theme;
  videos?: IntroVideos;
  firstFrame?: Camelized<Asset>;
  levels: Levels;
};

export type ParsedSplashScreen = Omit<SplashScreenResponse, 'mainScene'> & {
  scenes: Scene[];
  project: {
    apiPublished: boolean;
    portalPublished: boolean;
    stages: Stage[];
    buildings: Building[];
    units: Unit[];
  };
};

export const usePropertyExplorerSplashScreen = ({ sceneUuid }: { sceneUuid?: string }) => {
  const { uuid } = useParams();

  const [data, setData] = useState<ParsedSplashScreen>();

  useEffect(() => {
    getSplashScreenData<SplashScreenResponse>({ projectUuid: uuid, sceneUuid })
      .then((result) => {
        const data = camelizeKeys<SplashScreenResponse>(result);

        const scene: Scene = {
          ...data.mainScene,
          references: [],
          promotable: {
            uuid: data.project.uuid,
            type: 'project',
          },
        };

        const { mainScene: _, ...parsedData } = {
          ...data,
          project: {
            ...data.project,
            apiPublished: data.apiPublished,
            portalPublished: data.portalPublished,
            stages: [],
            buildings: [],
            units: [],
          },
          scenes: [scene],
        };

        setData({ ...parsedData, levels: result.levels });
      })
      .catch((err) => {
        console.debug(`Failed loading splash screen`, err);
      });
  }, [uuid, sceneUuid]);

  return data;
};
